import LogRocket from 'logrocket'
LogRocket.init('prn1t3/signal-test-app')
